import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloCours,cleanAloCours } from '@/models/alo/AloCours'
import { AlsCours, cleanAlsCours } from '@/models/als/AlsCours'

export default {
  getAllCours(): AxiosPromise<AlrContainer<Array<AloCours>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/Cours`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloCours>>
      }]
    })
  },
  getCours(id:number):AxiosPromise<AlrContainer<AloCours>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/Cours/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloCours>
      }]
    })
  },
  saveCours(cours:AloCours):AxiosPromise<AlrContainer<AloCours>> {
    cleanAloCours(cours)
    if(cours.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/Cours/${cours.id}`, 
        method: 'PUT',
        data: cours,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloCours>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/Cours`, 
        method: 'POST',
        data: cours,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloCours>
        }]
      })    
    }
  },
  deleteCours(id:number):AxiosPromise<AlrContainer<AloCours>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Cours/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloCours>
      }]
    })
  },
  getFilterCours(crsFilter : AlsCours): AxiosPromise<AlrContainer<Array<AloCours>>> {    
    cleanAlsCours(crsFilter)
    return apiHelpers.apiCall({ 
      url: `/webapi/Cours/filter`, 
      data:crsFilter,
      method: 'POST',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloCours>>
      }]
    })
  },
  addRange(cours : Array<AloCours>): AxiosPromise<AlrContainer<Array<AloCours>>> {    
    cours.forEach(c => cleanAloCours(c))
    return apiHelpers.apiCall({ 
      url: `/webapi/Cours/addRange`, 
      data:cours,
      method: 'POST',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloCours>>
      }]
    })
  },
  
}
